import { render, staticRenderFns } from "./ModalMotivoRecusaOrcamento.vue?vue&type=template&id=ff44a7f2&scoped=true"
import script from "./ModalMotivoRecusaOrcamento.vue?vue&type=script&lang=ts"
export * from "./ModalMotivoRecusaOrcamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalMotivoRecusaOrcamento.vue?vue&type=style&index=0&id=ff44a7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff44a7f2",
  null
  
)

export default component.exports